const FILL = "rgba(59, 130, 246, 0.14)";
const STROKE = "#3b82f6";

export function CircleShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <circle
        cx="28"
        cy="28"
        r="25"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
      />
    </svg>
  );
}

export function BalanceShape() {
  const cx = 28;
  const cy = 28;
  const r = 25;
  const spokes = [0, 60, 120, 180, 240, 300].map((deg) => {
    const rad = (deg * Math.PI) / 180;
    return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
  });

  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <circle
        cx={cx}
        cy={cy}
        r={r}
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
      />
      {spokes.map(([x, y], i) => (
        <line
          key={i}
          x1={cx}
          y1={cy}
          x2={x}
          y2={y}
          stroke={STROKE}
          strokeWidth="1.5"
        />
      ))}
    </svg>
  );
}

export function TriangleShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <polygon
        points="28,4 52,50 4,50"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <polygon
        points="4,20 30,20 30,8 52,28 30,48 30,36 4,36"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VennShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <circle
        cx="28"
        cy="18"
        r="15"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="1.75"
      />
      <circle
        cx="18"
        cy="37"
        r="15"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="1.75"
      />
      <circle
        cx="38"
        cy="37"
        r="15"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="1.75"
      />
    </svg>
  );
}

export function SquareShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <rect
        x="6"
        y="6"
        width="44"
        height="44"
        rx="10"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
      />
    </svg>
  );
}

export function NestedSquareShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <rect
        x="6"
        y="6"
        width="44"
        height="44"
        rx="10"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
      />
      <rect
        x="19"
        y="19"
        width="18"
        height="18"
        rx="5"
        fill="none"
        stroke={STROKE}
        strokeWidth="2"
      />
    </svg>
  );
}

export function GoalsShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <circle
        cx="28"
        cy="28"
        r="25"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
      />
      <polygon
        points="28,3 49.65,40.5 6.35,40.5"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <polygon
        points="28,53 6.35,15.5 49.65,15.5"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle
        cx="28"
        cy="28"
        r="14"
        style={{ fill: "var(--main-background)" }}
        stroke={STROKE}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function EqualsShape() {
  return (
    <svg viewBox="0 0 56 56" width="100%" height="100%">
      <rect
        x="8"
        y="16"
        width="40"
        height="9"
        rx="3"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
      />
      <rect
        x="8"
        y="31"
        width="40"
        height="9"
        rx="3"
        fill={FILL}
        stroke={STROKE}
        strokeWidth="2"
      />
    </svg>
  );
}
